import { gql } from "@apollo/client";

export const UPDATE_BOOKING_TYPE = gql`
  mutation UpdateBookingType(
    $bookingTypeId: Int! 
    $title: String
    $start: String
    $end: String
    $calendarSystem: String
    $scheduleTimezone: String
    $recurringInterval:Int
    $recurring: Recurring 
    $location: String
    $meetingLocationTypeId: String
    $desc: String
    $color: String
    $link: String
    $length: Int
    $maxInvitees: Int
    $price: Float
    $isPaymentRequired: Boolean
    $showRemaining: Boolean
    $bookingSize: String
    $bookingPerDay: Int 
    $increments: Int
    $isVisibleToStaff: Boolean
    $isPublic: Boolean
    $displayOnBookingPage: Boolean
    $phoneNumber: String
    $canInviteeCall: Boolean
    $image: Int
    $bookingApproval: Int
    $bookingTypeCategoryId : Int 
    $assignedStaffs: [StaffWithGroupIdInput]
    $businessId : Int
  ) {
    updateBookingType(
      bookingTypeId: $bookingTypeId 
      title: $title
      start: $start
      end: $end
      calendarSystem: $calendarSystem
      scheduleTimezone: $scheduleTimezone
      recurringInterval: $recurringInterval
      recurring: $recurring 
      location: $location
      meetingLocationTypeId: $meetingLocationTypeId
      desc: $desc
      color: $color
      link: $link
      length: $length
      maxInvitees: $maxInvitees
      price : $price 
      isPaymentRequired: $isPaymentRequired
      showRemaining: $showRemaining
      bookingSize: $bookingSize
      bookingPerDay: $bookingPerDay
      increments: $increments
      isVisibleToStaff: $isVisibleToStaff
      isPublic: $isPublic
      displayOnBookingPage: $displayOnBookingPage
      phoneNumber: $phoneNumber
      canInviteeCall: $canInviteeCall
      image: $image
      bookingApproval: $bookingApproval
      bookingTypeCategoryId: $bookingTypeCategoryId
      assignedStaffs: $assignedStaffs,
      businessId: $businessId
    ) {
      id
      title
      start
      end
      recurringInterval

      calendarSystem

      scheduleTimezone
      recurring
      location
      meetingLocationTypeId
      desc
      color
      link
      length
      maxInvitees
      price
      isPaymentRequired
      showRemaining
      bookingSize
      increments
      bookingPerDay
      isVisibleToStaff
      isPublic
      displayOnBookingPage
      phoneNumber
      canInviteeCall
      image
      bookingApproval
      bookingTypeCategoryId
      createdBy
      createdByAgentId
      assignedStaffs {
        bookingTypeStaffTblId
        name
        status
        groupId
        staffId
        permissionId
        hostNotifyEnabled
        hostReminderMinutes
        url
        business {
          name
        }
      }
    }
  }
`;
export const ADD_BOOKING_TYPE = gql`
  mutation AddBookingType( 
    $title: String!
    $start: String!
    $end: String! 
    $location: String!
    $meetingLocationTypeId: String!
    $desc: String!
    $color: String!
    $link: String!
    $length: Int!  
    $price: Float     
    $phoneNumber: String 
    $bookingTypeCategoryId : Int
    $assignedStaffs : [StaffWithGroupIdInput]!
    $createdBy : Int!
    $businessId: Int
    $canInviteeCall: Boolean
  ) {
    addBookingType( 
      title: $title
      start: $start
      end: $end 
      location: $location
      meetingLocationTypeId: $meetingLocationTypeId
      desc: $desc
      color: $color 
      link: $link
      length: $length  
      price : $price  
      phoneNumber: $phoneNumber  
      bookingTypeCategoryId: $bookingTypeCategoryId
      assignedStaffs: $assignedStaffs
      createdBy : $createdBy
      businessId: $businessId
      canInviteeCall: $canInviteeCall
    ) {
      id
      title
      start
      end
      recurringInterval

      calendarSystem

      scheduleTimezone
      recurring
      location
      status
      meetingLocationTypeId
      desc
      color
      link
      length
      maxInvitees
      price
      isPaymentRequired
      showRemaining
      bookingSize
      increments
      bookingPerDay
      isVisibleToStaff
      isPublic
      displayOnBookingPage
      phoneNumber
      canInviteeCall
    }
  }
`;

export const REMOVE_BOOKING_TYPES = gql`
  mutation ($bookingTypeId: Int!) {
    removeBookingType(bookingTypeId: $bookingTypeId)
  }
`;
export const CLONE_BOOKING_TYPE = gql`
  mutation CloneBookingType($bookingTypeId: Int!) {
    cloneBookingType(bookingTypeId: $bookingTypeId)
    {id}
  }
`;
